import React from 'react';
import { Controller, FieldError } from 'react-hook-form';

interface FormInputProps {
  name: string;
  control: any;
  label: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  onValueChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const FormInput: React.FC<FormInputProps> = ({
  name,
  control,
  label,
  placeholder,
  type = 'text',
  required,
  disabled,
  maxLength,
  onValueChange,
  onBlur
}) => {
  return (
    <div>
      <label className='block text-sm font-medium text-slate-700 mb-1'>
        {label} {required && <span className='text-red-500'>*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        render={({ field, formState: { errors } }) => {
          const error = errors[name] as FieldError | undefined;
          return (
            <>
              <input
                {...field}
                type={type}
                value={field.value || ''}
                placeholder={placeholder || ''}
                onChange={e => {
                  const value =
                    type === 'number'
                      ? e.target.value === ''
                        ? undefined
                        : parseFloat(e.target.value)
                      : e.target.value;
                  field.onChange(value);
                  if (onValueChange) onValueChange(e);
                }}
                onBlur={e => {
                  field.onBlur();
                  if (onBlur) onBlur(e);
                }}
                onKeyPress={e => {
                  if (type === 'number' && !/[0-9.]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                className={`border rounded px-2 py-1.5 w-full bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500 truncate ${
                  error ? 'border-red-500' : 'border-gray-300'
                }`}
                title={field.value || ''}
                disabled={disabled}
                maxLength={maxLength}
              />
              {error && (
                <p className='text-red-500 text-xs mt-1'>{error.message}</p>
              )}
            </>
          );
        }}
      />
    </div>
  );
};

export default FormInput;
